<template>
    <div class="notice03">
      <Nav :navSelectParent="1" />
    <div class='middle03'>
     <img :src="gxbg" alt="" class='gxbg'>
     <img :src="gxtitle" alt="" class='gxtitle'>
     <img :src="bgdi" alt="" class='bgdi'>
     <div class='feiji'>
         <h1 style='font-size:36px;color:#fff;margin-bottom:40px; text-align:center' class='biaot'>【光之圣境基础玩法】命运之塔</h1>
         <div class='dise'>
             <p>命运之塔奖励丰富，乃大佬炫富之地。本篇介绍基本玩法，及普通玩家怎么混~</p>
             <p>【命运之塔说明】</p>
             <p>1.是男人就上1000层，顾名思义爬塔玩法</p>
             <p>2.首通有奖：进阶石，金币之类的</p>
             <p>3.百败百战，就是每层不限制挑战次数，打过为止</p>
             <p>【命运之塔排行】</p>
             <p>1.新区3个赛季内是本服排行（每个赛季5天）</p>
             <p>2.开服15天后为跨服排名 奖励丰厚（圣境魂石，靠这个白嫖）</p>
             <p>3.报名时间内登录 自动报名。</p>
             <p>【干货——建议】</p>
             <p>本建议只对普通玩家，大佬不用管。</p>
             <p>1.确认本区战力，如果你是第一那就没办法了</p>
             <p>2.微氪建议优先强化治疗职业（后面说明）</p>
             <p>3.中氪建议练好治疗和坦克</p>
             <p>4.多求助于大佬，反正大佬也有奖励</p>
             <p>注意：</p>
             <p>1.求助后，支援者出2个战力最高的伙伴帮你打 所以你要有能抗住或者能治疗的伙伴。</p>
             <p>2.注意大佬的在线时间，一般凌晨0点 大佬都在 ，或者是在拍卖行开始期间进行求助。</p>
             <p>3.阵型选择建议【仙王阵】【北冕阵】【天箭阵】保证大佬有足够的时间输出。</p>
             <p>4.建议优先提升的伙伴</p>
             <p>1）治疗伙伴：平民 水奶第一 或者是 塞壬</p>
             <p>2）坦克：依据自己阵型选择对应属性坦克即可</p>
             <p>3）输出:阿波罗乃平民输出之王！宫本目测有BUG，被群里大佬称为‘’刮痧宫‘’</p>
             <p>4）保持良好心态~.</p>
             <p>5）除了光暗，目前火系阵容爬塔较快（多数大佬都卡在火系阵容），水系有前途~</p>
         </div>
     </div>
    </div>
     <div class='gankebottom'>
      <div class='ganke'><img :src="ganke" alt=""></div>
      <div class='btnContent'>
        <div><p>未成年人家长监护工程&nbsp;&nbsp;</p><P>网络游戏出版物号（ISBN）ISBN 978-7-498-07262-7</P></div>
          <div><p>审批文号：国新出审[2020]174 号&nbsp;&nbsp;</p><a href='screct.html'>隐私协议 |&nbsp;&nbsp;</a><a href='https://sdk.djsh5.com/h5game/user/agreement.html'>用户协议 |&nbsp;&nbsp;</a><a href="https://sdk.djsh5.com/h5game/user/antiaddiction.html">防沉迷系统&nbsp;&nbsp;</a><P>来文文号：津新出字[2019]232 号</P></div>
          <div><p>地址：上海市徐汇区虹漕路88号越虹广场B座6楼&nbsp;&nbsp;</p><p>电话：021-64660150&nbsp;&nbsp;</p><P>Email：bd@gank-studio.com</P></div>
          <div><p>抵制不良游戏，拒绝盗z版游戏。 注意自我保护，谨防受骗上当。 适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。</p></div>
      </div>
    </div>
    </div>
  </template>
<script>
import Nav from '../components/nav.vue'
export default {
  name: 'notice03',
  components: {
    Nav
  },
  data () {
    return {
      ganke: require('../assets/ganke.png'),
      imgUrl: require('../assets/nav.png'),
      leftIcon: require('../assets/icon.png'),
      shouter: require('../assets/shouted.png'),
      introduction: require('../assets/introduction.png'),
      characteristic: require('../assets/characteristic.png'),
      gxbg: require('../assets/gxbg.png'),
      gxtitle: require('../assets/gxtitle.png'),
      bgdi: require('../assets/bgdi.png')
    }
  }
}
</script>

<style scoped>
.imgUrl {
  position:absolute;
  width:100%;
  height:88px;
  line-height:88px;
}
.row {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  height:88px;
  padding:0 10%;
  box-sizing: content-box;
}
.iconUl {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  box-sizing: content-box;
}
ul li {
  list-style: none;
}
.middle03 {
  position:relative;
}
.gxbg {
  position:relative;
  width:100vw;
}
.gxtitle {
    position:absolute;
    top:40%;
    left:50%;
    margin-left:-580px;
}
.bgdi {
    position:absolute;
    top:55%;
    left:50%;
    margin-left:-668px;
}
.feiji {
    position:absolute;
    top:60%;
    width:60%;
    left:20%;
}
.dise {
    width:100%;
    max-height:350px;
    overflow:scroll;
    background-color:#eee9e0;
    font-size:22px;
    color:#000;
    padding:30px 0
}
.dise p {
    display:block;
    line-height:42px;
    padding:0 25px;

}
.gankebottom {
  width:100vw;
  padding:50px 0;
  background-color:#000;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color:#fff;
  margin-top:-15px;
}
.btnContent {
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size:18px;
}
.btnContent div {
  display:flex;
  flex-direction: row;
}
.btnContent a {
  color: rgb(250, 171, 25);
  cursor: pointer;
}
.ganke {
  margin-right:30px
}
.ganke img{
  width:152px;
  height:60px;
}
@media screen and (max-width: 1300px) {
  .bgdi{
    position: absolute;
    top: 55%;
    width: 80%;
    left: 63% !important;
    height: 525px !important;
}
.feiji {
  top:58%
}
.dise {
  height:350px;
  font-size:20px;
}
.biaot {
  font-size:30px !important;
  margin-bottom:10px !important
}
.gxtitle{
    position: absolute;
    top: 44%;
    left: 25%;
    width: 50%;
    margin-left:0
}
}
</style>



// WEBPACK FOOTER //
// src/pages/notice03.vue